import { LocationNodeData } from '../../../@types';

export enum SearchParams {
  ParentId = 'parentId',
  ParentName = 'parentName',
  NodeTypeCode = 'nodeTypeCode',
  PreferedNodeType = 'preferedNodeType',
  ClientId = 'clientId',
  ContractId = 'contractId'
}

export interface AddEditStructureLocationProps {
  pageType?: string;
  structureId?: string;
  locationType?: string;
  locationText?: string;
  mainLocationNode?: LocationNodeData;
  setMainLocationNode?: ((locationNode?: LocationNodeData) => void) | undefined;
  onSetCreatedLocation?: (createdLocationId: number) => void;
  setSubLocationNode?: ((locationNode?: LocationNodeData) => void) | undefined;
  setLocationText?: (locationtext: string) => void;
  setOpenLocationCreateUpdatePopup?: (isOpen: boolean) => void;
}